import type {GlobalState} from 'types/store';

import {threadsAdapter} from '../entity_adapters/thread_entity_adapter';
import type {ClientThread} from '../types/extended';

import {getUserThreadsSliceState} from './get_user_threads_state';

export const selectThreadById = (state: GlobalState, id: ClientThread['id']) => {
    const userThreads = getUserThreadsSliceState(state).threads;
    return threadsAdapter.getSelectors().selectById(userThreads, id);
};
